import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import Popup from '../Popup/index';
import BoxPopup from '../../containers/TreePage/BoxPopup';
import AssetCache from '../../services/cache/AssetCache';
import { AccountAssetsOpen } from '../../services/Pagination/index';
import Scrollable from '../Scrollable';
import MediaUploadTile from '../MediaUploadTile';
import Constants from '../../submodules/logictry_config/constants';
import UserAccount from '../../services/UserAccount';
import Company from '../../services/Company';
import AppConstants from '../../submodules/logictry_config/s3_config.json';

const Wrapper = styled.div`
  align-items: center;
  width: 864px;
  max-width: 100%;
  padding: 2rem 3rem;
  h1 {
    text-align: center;
    margin-bottom: 1.5rem;
  }
  > div:last-child {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    padding: 0.5rem 0 2rem;
    width: 100%;
    > div {
      margin: 1rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
  }
`;

export default class AssetsPopup extends BoxPopup {
  static propTypes = {
    onClose: PropTypes.func,
  }
  componentDidMount() {
    AssetCache.onStateUpdate(this);
    AccountAssetsOpen.onStateUpdate(this);
  }
  componentWillUnmount() {
    AssetCache.offStateUpdate(this);
    AccountAssetsOpen.offStateUpdate(this);
  }
  onPagination = () => {
    if (AccountAssetsOpen.showMore && AccountAssetsOpen.allFound && AccountAssetsOpen.initialized) {
      AccountAssetsOpen.getMore();
    }
  }
  render() {
    const { onClose } = this.props;
    const { currentPage } = AccountAssetsOpen;
    if (!currentPage) return null;
    let s3Path;
    let signingUrl;
    if (Company.company && Company.company._id) {
      s3Path = `${Company.company._id}/${UserAccount.account._id}/`;
      signingUrl = `/v1${AppConstants.S3.signingUrls.companyfiles}`;
    } else {
      s3Path = `${UserAccount.account._id}/`;
      signingUrl = `/v1${AppConstants.S3.signingUrls.userfiles}`;
    }
    return (
      <>
        <Popup
          showCloseButton
          onClose={onClose}
          allowBackgroundClose
        >
          <Scrollable
            vertical
            paginationHeight={200}
            onPagination={this.onPagination}
            style={{ width: '100%' }}
            popupMaxHeight
          >
            <Wrapper>
              <h1>Assets</h1>
              <div>
                <div style={{ position: 'relative', width: Constants.BoxSize, height: Constants.BoxSize }}>
                  <MediaUploadTile
                    s3Path={s3Path}
                    signingUrl={signingUrl}
                    additionalQueryParams={{
                      team: this.props.team || '',
                    }}
                    style={{
                      width: Constants.BoxSize,
                      height: Constants.BoxSize,
                      borderRadius: Constants.BoxRadius,
                      backgroundSize: 'contain',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      border: '1px dashed'
                    }}
                    onUploadFinish={() => {
                      AssetCache.clearAccountObjects();
                    }}
                  />
                </div>
                {currentPage.map(({ _id, link, background, type, createdTime }) => (
                  <div key={_id} style={{ position: 'relative', width: Constants.BoxSize, height: Constants.BoxSize }}>
                    <MediaUploadTile
                      style={{
                        width: Constants.BoxSize,
                        height: Constants.BoxSize,
                        borderRadius: Constants.BoxRadius,
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                      }}
                      backgroundImage={link}
                      backgroundColor={background?.color}
                      fileType={type}
                      createdTime={createdTime}
                      disableEditing
                      showUrl
                    />
                  </div>
                ))}
              </div>
            </Wrapper>
          </Scrollable>
        </Popup>
      </>
    );
  }
}
